import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';
import { initials } from '../../utils/formatters';

const colorFromNumber = (n) => {
  const colors = [
    'from-accent-400 to-accent-600',
    'from-cyan-400 to-cyan-600',
    'from-emerald-400 to-emerald-600',
    'from-amber-400 to-amber-600',
    'from-rose-400 to-rose-600',
    'from-blue-400 to-blue-600',
  ];
  return colors[Math.abs(n) % colors.length];
};

export default function StatCard({ label, value, sub, icon, index = 0, className }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.08, duration: 0.5 }}
      className={cn(
        'bg-white rounded-2xl border border-surface-200/80 p-5 shadow-subtle',
        className,
      )}
    >
      {icon && (
        <div className={cn('w-10 h-10 rounded-xl bg-gradient-to-br flex items-center justify-center text-white text-lg mb-3', colorFromNumber(index))}>
          {icon}
        </div>
      )}
      <p className="text-xs font-semibold text-navy-400 uppercase tracking-wider mb-1">{label}</p>
      <p className="text-2xl font-bold text-navy-900 tracking-tight">{value}</p>
      {sub && <p className="text-sm text-navy-400 mt-0.5">{sub}</p>}
    </motion.div>
  );
}

/* Small avatar circle */
export function Avatar({ name, size = 'md', className }) {
  const s = size === 'sm' ? 'w-8 h-8 text-xs' : size === 'lg' ? 'w-14 h-14 text-lg' : 'w-10 h-10 text-sm';
  const hash = (name || '').split('').reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return (
    <div className={cn('rounded-full bg-gradient-to-br flex items-center justify-center text-white font-bold', colorFromNumber(hash), s, className)}>
      {initials(name)}
    </div>
  );
}
